import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { SidebarDarkExample } from "./components/NavbarExample.js";
import "@coreui/coreui/dist/css/coreui.min.css";
import TableExample from "./components/ds_nhansu";
import BieuDo from "./components/bieu_do.js";
import EmployeeDetail from "./components/ChiTietNhanSu.js";
import PhongBan from "./components/ds_PhongBan.js";
import PbChiTiet from "./components/PbChiTiet.js";
import FormChinhSuaNhanSu from "./components/FormChinhSuaNhanSu.js";
import XemLichLamViec from "./components/XemLich.js";
import TaoLichLamViec from "./components/tao_lich.js";
import BangLuong from "./components/BangLuong.js";

function App() {
  const [schedule, setSchedule] = useState(null);

  return (
    <Router>
      <div style={{ display: "flex", height: "100vh" }}>
        <SidebarDarkExample />
        <div style={{ flex: 1, padding: "20px" }}>
          <Routes>
            <Route path="/" element={<BieuDo />} />
            <Route path="/ds_nhansu" element={<TableExample />} />
            <Route path="/nhan-su/:id" element={<EmployeeDetail />} />
            <Route path="/ds_PhongBan" element={<PhongBan />} />
            <Route path="/phongban/:id" element={<PbChiTiet />} />
            <Route path="/edit/:id" element={<FormChinhSuaNhanSu />} />
            <Route
              path="/xem_lich"
              element={<XemLichLamViec schedule={schedule} />}
            />
            <Route
              path="/tao_lich"
              element={<TaoLichLamViec onSave={setSchedule} />}
            />
            <Route path="/BangLuong/:id" element={<BangLuong />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
